<template>
  <!-- sidenav -->
  <div class="iframe-section" style="display: flex">
    <div class="krx-sidenav">
      <div
        class="side-title"
        style="padding-top: 11px; cursor: pointer;"
        @click="goLogo('myMeeting')"
      >
        <img
        style="width: 130px;"
            src="/static/ksd/logo.svg"
          />
      </div>
      <button
        class="join-meeting-btn"
        style="width: 70%;
        margin-left: 15%;
        height: 40px;
        margin-top: 20px;"
        @click="openJoinMeetingDialog"
      >
        회의 접속
      </button>
      <ul style="margin-top: 24px;">
        <li :class="page.class" v-for="page in pageList" :key="page.link">
          <div class="side-list" style="margin-top: 5px;" @click="currentPage(page)">
            <img :src="page.imagePath" />
            <div class="txt">{{ page.title }}</div>
          </div>
          <div
            v-for="obj in page.child"
            :key="obj.href"
            class="flex flex-row items-center child-row side-list"
            
          >
            <img
              :class="obj.class"
              style="margin-left: 15px;"
              :src="obj.imagePath"
            />
            <span :class="obj.class">{{ obj.title }}</span>
          </div>
        </li>
      </ul>

      <citizen-participation-dialog
        :dialog="citizenParticipationDialog.dialog"
        :closeDialog="closeJoinMeetingDialog"
      />
    </div>
    <iframe
      id="kMeetingIframe"
      class="kmeeting-iframe"
      :src="iframeLink"
    ></iframe>
  </div>
</template>

<script>
import Util from '@/util';
import CitizenParticipationDialog from '@/components/popup/CitizenParticipationDialog';
export default {
  components: {
    CitizenParticipationDialog,
  },
  data: () => ({
    iframeLink: '/sMeetingFrame',
    citizenParticipationDialog: {
      dialog: false,
    },
    isActive: false,
    pageList: [
      {
        class: 'm02',
        link: '/myMeeting',
        title: '영상회의',
        imagePath: '/static/icon-contents/video.svg',
      },
      {
        class: 'active',
        link: 'conf',
        title: '스마트회의록',
        imagePath: '/static/icon-contents/write.svg',
      },
    ],
  }),
  created () {
    if (!Util.hasSession(this, true)) return;
  },
  methods: {
    async currentPage (obj) {
      console.log(obj);
      if (obj.title === '회의실 신청') {
        window.open(obj.link, '_blank');
      } else if (obj.link === '#') {
        alert('준비중인 서비스입니다.');
      } else if (obj.link === '/myMeeting') {
        location.reload();
      } else if (obj.link === 'conf') {
        // this.iframeLink = 'https://istt-smeeting-d.ksd.or.kr:8082';
        this.iframeLink = (await this.$http.get('/api/auth/redirectUrl', { params: { type: 'conf' }})).data.url;
        // window.open(redirectUrl,
        //   '_blank'
        // );
      } else {
        this.$router.push(obj.link);
      }
      this.pageList.forEach((element) => {
        element.isActive = false;
      });

      obj.isActive = true;
    },
    goLogo () {
      this.$router.go(0);
    },
    goUserPage () {
      this.$router.push(`/myMeeting`);
    },
    openJoinMeetingDialog () {
      this.citizenParticipationDialog.dialog = true;
    },
    closeJoinMeetingDialog () {
      this.citizenParticipationDialog.dialog = false;
    },
  },
};
</script>

<style scoped>
.side-list {
  display: flex;
  flex-direction: row;
  justify-items: center;
  align-items: center;
  margin-left: 30px;
  height: 32px;
  width: 173px;
  cursor: pointer;
  font-size: 13px;
  color: #333;
}

.side-list img {
  width: 18px;
  height: 18px;
}
.side-list:hover {
  border-radius: 4px;
  background: rgba(100, 73, 252, 0.06);
}
.txt {
  margin-left: 6px;
  font-size: 13px;
  color: #333;
}

.child-row span {
  font-size: 13px;
  margin-left: 6px;
}

.no-active {
  color: #cccccc;
}
</style>



// WEBPACK FOOTER //
// src/components/krx/KrxLeftSide.vue